import { Resource } from "i18next";
import t from "../../locales/en.json";

export default t as Resource;
